import React from 'react';

const Gallery = () => {
  const images = [
    {
      url: 'https://images.pexels.com/photos/7195799/pexels-photo-7195799.jpeg?auto=compress&cs=tinysrgb&w=600',
      alt: 'Stylish salon interior with contemporary design',
    },
    {
      url: 'https://images.pexels.com/photos/3993293/pexels-photo-3993293.jpeg?auto=compress&cs=tinysrgb&w=600',
      alt: 'Modern salon with illuminated mirrors',
    },
    {
      url: 'https://images.pexels.com/photos/3993308/pexels-photo-3993308.jpeg?auto=compress&cs=tinysrgb&w=600',
      alt: 'Bright salon with modern equipment',
    },
    {
      url: 'https://images.pexels.com/photos/853427/pexels-photo-853427.jpeg?auto=compress&cs=tinysrgb&w=600',
      alt: 'Spacious chic salon interior',
    },
    {
      url: 'https://images.pexels.com/photos/5659018/pexels-photo-5659018.jpeg?auto=compress&cs=tinysrgb&w=600',
      alt: 'Relaxing spa treatment session',
    },
    {
      url: 'https://images.pexels.com/photos/5659055/pexels-photo-5659055.jpeg?auto=compress&cs=tinysrgb&w=600',
      alt: 'Professional facial treatment',
    },
  ];

  return (
    <section id="gallery" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Salon
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Step into elegance. Experience our premium facilities and relaxing ambiance designed for your comfort.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className="relative overflow-hidden rounded-xl shadow-lg group cursor-pointer aspect-square"
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              {/* Overlay on hover */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <p className="text-white text-sm p-4">{image.alt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;